import React, {useState, useEffect} from 'react';
import Column from './Column';
import SocialLinks from './SocialLinks';

function Footer({simplified}) {
    const [links, setLinks] = useState();
    const [service, clients, lawyers, social_links] = links || '';

    useEffect(() => {
        fetch('/api/footer-links/').then(res => {
            res.json().then(data => {
                setLinks(data)
            })
        })
    }, [])

    if (links) {
        return (
            <div className="footer">
                <div className="container">
                    <div className="row" id="footer-row">
                        <Column links={service} index={0} simplified={simplified}/>
                        <Column links={clients} index={1} simplified={simplified}/>
                        <Column links={lawyers} index={2} simplified={simplified}/>
                        <SocialLinks links={social_links}/>
                    </div>
                </div>
            </div>
        )
    }
}





export default Footer;